
import { ref ,watch} from 'vue';
import { useRoute } from "vue-router";
export default {
  props: {
    isShowPopUp:{
      type: Boolean,
      default: true,
    },
    app_adjust_arr:{
      type: Array
    }
  },
  setup(props: any, { emit }: any) {
    let route = useRoute();
    let bannerListNum = ref(Math.floor(Math.random() * 2))
    

    const randomGoodswriter = [
      {
        title: "Reliable One Stop Online Shopping Place",
        content:
          "Everything Quality at Affordable Price. Everyday Delivery. ",
        url: props.app_adjust_arr[0],
      },
      {
        title: " Page Loading Slowly? ",
        content: "Enjoy Fast Shopping Experience with Kilimall App. ",
        url: props.app_adjust_arr[1],
      },
    ]; 
    watch(() => props.app_adjust_arr,(newData,old) => { 
      randomGoodswriter[0].url = newData[0]
      randomGoodswriter[1].url = newData[1]
     })
    if (
      route.fullPath.includes("/goods") &&
      !localStorage.getItem("expiredate")
    ) {
      props.isShowPopUp = true
    } else {
      props.isShowPopUp = false
    }
    var timer = setInterval(() => {
      if (localStorage.getItem('expiredate')) {
        var name:any = localStorage.getItem('expiredate')
        var nameObj = JSON.parse(name)
        if (new Date().getTime() - nameObj.time >= nameObj.expire) {
          localStorage.removeItem('expiredate')
          // window.location.reload()
        }
      } else {
        clearInterval(timer)
      }
    }, 1000)
    const openApp = function (url :any) {
      var sUserAgent:any = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      if (bIsIpad || bIsIphoneOs) {
        window.location.href =
          "https://apps.apple.com/cn/app/kilimall/id1454600768";
      } else {
        window.location.href = url;
      }
    };

    const closeFn = () => {
      let expiredate = {
        time: new Date().getTime(),
        expire: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1  - new Date().getTime(),
        // expire: 5000//过期时间测试
      };
      localStorage.setItem("expiredate", JSON.stringify(expiredate));
          emit("closeFn", false);

    };

    return {
      closeFn,
      randomGoodswriter,
      bannerListNum,
      openApp
    }
  }
};
